import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import './assets/style.css';
import './assets/karmuh-custom.css';

import reportWebVitals from './reportWebVitals';
import Main from './components/Main';
import Event from './services/Event';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

reportWebVitals(Event.analytics);
